import { combineReducers } from "redux";
import { authReducer } from "./authReducer";
import { scanTMRZReducer } from "./scanTMRZreducer";
import { alertReducer } from "./alertReducer";
import cameraReducer from "./cameraReducer";
import { pendingRequestReducer } from "./pendingRequestReducer";
import { dataReducer } from "./dataReducer";
import configReducer from "./configReducer";
import { tabReducer } from "./tabReducer";
import { registerExitReducer } from "./registerExitReducer";

export const rootReducer = combineReducers({
  auth: authReducer,
  alertGlobal: alertReducer,
  scanMrz: scanTMRZReducer,
  camera: cameraReducer,
  pendingRequest: pendingRequestReducer,
  data: dataReducer,
  config: configReducer,
  tabs: tabReducer,
  exits: registerExitReducer,
});
export type RootState = ReturnType<typeof rootReducer>;
